export default "__VITE_ASSET__DHejwAax__"